import ruleSetStepsSlice from './ruleSetsSteps';

export {
    default as getStepsCompletion,
    recomputeInformationStatus,
    recomputeSortingRulesStatus,
    recomputeBreakRulesStatus,
} from './ruleSetsStepsCompletion';

export {
    informationStepStatusSelector,
    sortingRulesStepStatusSelector,
    breakRulesStepStatusSelector,
    exceptionRulesStepStatusSelector,
} from './ruleSetsSteps';

const { actions } = ruleSetStepsSlice;

export const {
    createRuleSetSteps,
    editRuleSetSteps,
    setInformationStep,
    setSortingRulesStep,
    setBreakRulesStep,
    setExceptionRulesStep,
} = actions;

export default ruleSetStepsSlice;
